/**
 * Env-aware base URL for accounts-app HTTP endpoints (auth + follow/star writes).
 *
 * The accounts-app endpoints (`/accounts/...`) are served by the backend-proxy
 * (Cloudflare worker), whose host is `app.flux.ai` in production and
 * `pr-{N}.app.flux.ai` on a PR preview. This is NOT the same host that serves
 * the site-search app itself (`www.flux.ai` / `pr-{N}.preview.flux.ai`).
 *
 * Mirrors `getBackendBase()` in `apps/internal-app` — the host is the reliable
 * runtime signal because these Vite builds have no `REACT_APP_*` env injection.
 */

/** Extracts the PR number from a host (e.g. `pr-28080.preview.flux.ai` → `"28080"`), else null. */
export function getPrNumberFromHost(host: string): string | null {
    const match = /^pr-(\d+)\./.exec(host);
    return match?.[1] ?? null;
}

/** Backend-proxy base for the given host, env-aware so previews hit their own accounts-app. */
export function getAccountsApiBaseForHost(host: string): string {
    const pr = getPrNumberFromHost(host);
    return pr ? `https://pr-${pr}.app.flux.ai` : "https://app.flux.ai";
}

/** Backend-proxy base resolved from the current browser location. Client-side only. */
export function getAccountsApiBase(): string {
    return getAccountsApiBaseForHost(window.location.hostname);
}
